module.exports = __webpack_public_path__ + "img/product_video5.2b6975e3.jpg";